import React from "react";
import PropTypes from "prop-types";
import { PaginationLink, StepperWrapper } from "./styled";
import FirstPageIcon from "./icons/FirstPageIcon";
import PrevPageIcon from "./icons/PrevPageIcon";

const BackSteppers = props => {
  const { currentPage, pathRoot } = props;
  const prevPageLink =
    currentPage - 1 <= 1 ? `${pathRoot}/` : `${pathRoot}/${currentPage - 1}`;

  return (
    <StepperWrapper>
      <PaginationLink
        key="pagination-start"
        className={`hide-on-mobile ${currentPage === 1 ? "disabled" : ""}`}
        to={`${pathRoot}/`}
      >
        <FirstPageIcon disabled={currentPage === 1} />
      </PaginationLink>
      <PaginationLink
        key="pagination-prev"
        className={currentPage === 1 ? "disabled" : ""}
        to={prevPageLink}
      >
        <PrevPageIcon disabled={currentPage === 1} />
      </PaginationLink>
    </StepperWrapper>
  );
};

BackSteppers.propTypes = {
  pathRoot: PropTypes.string,
  currentPage: PropTypes.number
};

BackSteppers.defaultProps = {
  pathRoot: "",
  currentPage: 1
};

export default BackSteppers;
